import SnippetsGrid from '../../components/snippetsGrid';
import { Link } from "react-router-dom";
import {linkStyle} from "../../components/helpersStyles";
//import { IconButton, Tooltip } from '@mui/material';
//import { Icon as Iconify } from '@iconify/react';
import { CcCreateNewSnippet, CcSubSectionTitle, CcTitle } from '../../commonComponents/styledTexts';
import { useEffect } from "react";
import { InfoToolTip } from "../../commonComponents/generalComponents"

export default function ProductHomeMemoryCards() {
    useEffect(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }, [])

    return <div>
            <div className='flex flex-row items-center gap-x-2'>
                <InfoToolTip 
                        placement='right'
                        headLine='You will need'
                        message={<div className='flex flex-col'><div>A cover image</div> 
                            <div>A background image</div>
                            <div>Company logo</div>
                            <div>URL for final landing page</div>
                            <div>Branded content - title, text, button text</div>
                            </div>}
                        />
            <CcTitle>
                Memory Cards
            </CcTitle>
            </div>

            <div className=" text-ccColorDarkTeal">Create engaging animated GIFs that drive clicks to a branded landing page, where recipients can ‘scratch off’ to reveal exclusive offers—bringing gamification, fun, and interactivity to their inbox.</div>

            <Link to={`/workflow/22`} style={linkStyle}>
                <CcCreateNewSnippet className="mt-4" >Create Memory Cards</CcCreateNewSnippet>
            </Link>

            <CcSubSectionTitle className=" mt-6">Latest Memory Cards Elements</CcSubSectionTitle>
            <SnippetsGrid productTypeId={22}
                 //editCall={(id, typeId) => editSnippet(id, typeId)}
             />

    </div>
}